import React from 'react'
import { Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import '../../style.scss'

const DeveloperHeader = () => {
    const {t} = useTranslation();

    return (
        <div className="create">
            <div className='user_header'>
                <div className='user_image'>
                    <img src='/assets/img/dashboard-user.png' />
                </div>
                <Row>
                    <div className="col-lg-3 mt-2">
                        <Link to="/dashboard/saloons" className="dashboard-create">
                            <div className='dashboard-create-image'><img src='./assets/img/shop.png' alt="shop" /></div>
                            <h6> {t("dashboard_nav_saloons_management")} </h6>
                        </Link>
                    </div>
                    <div className="col-lg-3 mt-2">
                        <Link to="/dashboard/developer-companies-management" className="dashboard-create">
                            <div className='dashboard-create-image'><img src='./assets/img/stall.png' alt="company" /></div>
                            <h6> {t("dashboard_nav_companies_management")} </h6>
                        </Link>
                    </div>
                    <div className="col-lg-3 mt-2">
                        <Link to="/dashboard/users-management" className="dashboard-create">
                            <div className='dashboard-create-image'><img src='./assets/img/users.png' alt="users" /></div>
                            <h6> {t("dashboard_nav_users_management")} </h6>
                        </Link>
                    </div>
                    <div className="col-lg-3 mt-2">
                        <Link to="/dashboard/site-management" className="dashboard-create">
                            <div className='dashboard-create-image'><img src='./assets/img/website.png' alt="website" /></div>
                            <h6> {t("dashboard_nav_site_management")} </h6>
                        </Link>
                    </div>
                </Row>
            </div>
        </div>
    )
}

export default DeveloperHeader
